export default {
  getIsSameAddress: state => state.isSameAddress,
  getCep: state => state.cep,
  getAddress: state => state.address,
  getNumber: state => state.number,
  getNoNumber: state => state.noNumber,
  getNeighborhood: state => state.neighborhood,
  getState: state => state.state,
  getCity: state => state.city,
  getCityId: state => state.cityId,
  getStateId: state => state.stateId,
  getSecondaryAddress: state => state.secondaryAddress
}
